// extracted by mini-css-extract-plugin
export default {"campaignOverview":"CampaignOverview_campaignOverview__8GpiE","tableWrapper":"CampaignOverview_tableWrapper__SjRVR"};